export default "__VITE_ASSET__5e0e60a0__"